export const HEADER_PHRASES = {
    LOGIN: 9,
    CONTACT_US: 110,
    CONTACT_US_URL: 21446,
    FAQ: 1783,
    FAQ_URL: 17584,
    HELP_CENTRE: 21445,
    HELP_CENTRE_URL: 21447,
    ABOUT: 15952,
    BLOG: 2141,
    BLOG_URL: 17583,
    ACCOUNT: 2747,
    SURVEYS: 15963,
    REFERRALS: 15964,
    PROFILE: 15965,
    WALLET: 15966,
    LOGOUT: 10,
    LANGUAGE_SWITCH_CONFIRM: 17074,
};
